import { Component, Vue, Watch } from 'vue-property-decorator';
import { Brand } from '@/models/Brand';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Brands/CreateDialog';

@Component<Brands>({
  components: {
    CreateDialog,
  },
})
export default class Brands extends Vue {

  protected selectedBrand: Brand | null = null;
  protected isCreatingBrand: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() { }

  get tableOptions(): Object {
    return {
      model: new Brand().include('supplier'),
      name: {
        singular: 'Brand',
        plural: 'Brands',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
        },
        {
          text: 'Shortcode',
          value: 'short_name',
          sortable: {
            key: 'short_name',
            order: 'ASC',
          },
        },
        {
          text: 'Active',
          value: 'is_active',
          sortable: {
            key: 'active',
            order: 'ASC',
          },
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, Brand: Brand) => {
            this.selectedBrand = Brand;
            this.isCreatingBrand = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, Brand: Brand) => {
            this.selectedBrand = Brand;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingBrand = true;
      }
    };
  }

  protected get brandsDatatable(): DataTable | null {
    const dataTable = this.$refs.brandsDatatable;
    if (dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedBrand as Brand).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this brand?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedBrand) {
              return;
            }

            this.selectedBrand
              .delete()
              .then((response: any) => {
                if (response) {
                  this.brandsDatatable ? this.brandsDatatable.refresh(true) : null;
                  this.selectedBrand = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedBrand = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingBrand')
  protected isCreatingBrandChanged() {
    if (!this.isCreatingBrand) {
      this.selectedBrand = null;
    }
  }
}
